export const MIN_CHARACTERS = 2;
